// frontend/src/Pages/Terms.jsx
import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const Terms = () => {
  return (
    <Box sx={{ minHeight: '700px', bgcolor: '#F8FAFC', py: 6 }}>
      <Container maxWidth="lg">
        <Paper elevation={6} sx={{ p: { xs: 4, md: 5 }, borderRadius: 3 }}>
          {/* Header matching Contact/FAQ style */}
          <Box textAlign="center" mb={4}>
            <Typography variant="h4" fontWeight={700} color="#1a7f3a" gutterBottom>
              Terms & Conditions
            </Typography>
            <Typography color="text.secondary">
              Please read our terms carefully
            </Typography>
          </Box>
          
          {/* Body Content with matching typography */}
          <Typography variant="h6" color="#1a7f3a" sx={{ mt: 3, mb: 1 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            By creating an account or using our services, you confirm that you accept these terms and agree to follow them.
          </Typography>

          <Typography variant="h6" color="#1a7f3a" sx={{ mt: 3, mb: 1 }}>
            2. Membership Requirements
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            <strong>User Membership:</strong> To view and access all deals on our platform, users must create an account and sign up. Only registered members can browse the deals.
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            <strong>Vendor Membership:</strong> Vendors must also create an account to upload, update, and manage their deals. All information provided must be accurate and truthful.
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            <strong>Accuracy of Information:</strong> Both users and vendors are required to provide correct, complete, and up-to-date information. Providing false or misleading information may lead to account suspension.
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            <strong>Unauthorized Activities:</strong> If we detect any unauthorized, illegal, fraudulent, or harmful activities, we reserve the right to suspend, restrict, or terminate the account without prior notice.
          </Typography>

          <Typography variant="h6" color="#1a7f3a" sx={{ mt: 3, mb: 1 }}>
            3. Data Usage
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            We may use the information you share with us to improve our website and services. This helps us understand user preferences, show relevant deals, enhance website performance, and keep the platform safe. We use all information responsibly and only for service improvement.
          </Typography>

          <Typography variant="h6" color="#1a7f3a" sx={{ mt: 3, mb: 1 }}>
            4. Platform Disclaimer & Responsibility
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Our platform acts solely as an intermediary that connects local vendors with users. We do not create, manage, control, verify, or guarantee any deals, offers, prices, products, or services. All content is submitted and maintained entirely by the vendors. We are not responsible for the accuracy, quality, or availability of any deals, nor for any disputes between users and vendors. All interactions are conducted at your own risk.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Terms;